import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import type { Route } from '@/types';
import { useBlackText, hasAlerts, hasSevereAlert } from '../../utils/routeHelpers';
import { RouteCardFront } from './RouteCardFront';
import { RouteCardBack } from './RouteCardBack';

interface RouteCardProps {
  route: Route;
  onHide?: (routeId: string) => void;
}

export function RouteCard({ route, onHide }: RouteCardProps) {
  const { t } = useTranslation();
  const isWhite = useBlackText(route);
  const showAlerts = hasAlerts(route);
  const isSevere = hasSevereAlert(route);

  const flipCardClasses = classNames('flip-card', {
    'white': isWhite,
    'route-active': isSevere,
    'has-alerts': showAlerts,
    'has-severe-alert': isSevere,
  });

  const textColor = isWhite ? '#000000' : `#${route.route_color}`;

  return (
    <div data-route-card>
      <div className="route-inner">
        {onHide && (
          <button
            className="hide-route"
            onClick={() => onHide(route.global_route_id)}
          >
            {t('hide')}
          </button>
        )}
        <div className={flipCardClasses} style={{ color: textColor }}>
          <div className="flip-card-inner">
            <RouteCardFront route={route} isWhite={isWhite} />
            <RouteCardBack route={route} />
          </div>
        </div>
      </div>
    </div>
  );
}
